import * as React from "react"
import { Typography, Box, Stack } from "@mui/material";


function ExpandableText({ shortText, fullText }) {
  const [showFull, setShowFull] = React.useState(false);

  let text=shortText.split("\n").map((line, index) => (
    <span key={index}>
      {line}
      <br />
    </span>
  ));

  if (showFull) {
    text=fullText.split("\n").map((line, index) => (
      <span key={index}>
        {line}
        <br />
      </span>
    ));

  }

  let action=<></>;

  if (showFull) {
    action=<Typography variant="body1" onClick={()=>setShowFull(false)}       sx={{
        textAlign: 'right',    // Align text to the right
        textDecoration: 'underline', // Underline the text
        color: 'blue',         // Make text blue
      }}>縮回</Typography>;

  } else if (fullText!=null) {
    action=<Typography variant="body1"       sx={{
        textAlign: 'right',    // Align text to the right
        textDecoration: 'underline', // Underline the text
        color: 'blue',         // Make text blue
      }}
      onClick={()=>setShowFull(true)}>展開</Typography>;
  }

  return <>{text}<br/>{action}</>
}

export default ExpandableText;
